import UserProfileReducer from 'store/user-profile/reducer';

export default UserProfileReducer;
